import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "timeline-item" }
const _hoisted_3 = { class: "timeline-item__property" }
const _hoisted_4 = { class: "timeline-item__property" }
const _hoisted_5 = { key: 1 }

import { ref, computed, onMounted } from 'vue'
import { TripFull } from '@/models/trip'
import { formatDateWithTime } from '@/helpers/date'
import { useTripsStore } from '@/store/trips'
import CommonError from '@/components/CommonError.vue'
import Loader from '@/components/Loader.vue'
import { ElNotification } from 'element-plus'
import axios from 'axios'


export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceLogs',
  props: {
    trip: {}
  },
  setup(__props: any) {

const props = __props

const tripsStore = useTripsStore()

const listModule = computed(
  () => tripsStore.insuranceLogs[props.trip.id]?.listModule
)

const list = computed(() => listModule.value?.list || [])
const error = computed(() => listModule.value?.error)
const isLoading = computed(() => listModule.value?.isLoading)
const isInitialLoadingDone = computed(
  () => listModule.value?.isInitialLoadingDone
)

const getInsuranceLogs = () => {
  tripsStore.getInsuranceLogs(props.trip.id)
}

const resendInsuranceState = ref<'idle' | 'loading' | 'success' | 'error'>(
  'idle'
)
const errorMessage = ref<string>('')

const resendInsurance = async () => {
  resendInsuranceState.value = 'loading'
  try {
    const response = await axios.post(
      `${process.env.VUE_APP_API_HOST}/admin/insurance/recreate-insurance`,
      { trip: props.trip }
    )
    resendInsuranceState.value = 'success'
    ElNotification({
      title: 'Success',
      message: 'Insurance Resent Successfully!',
      type: 'success',
      position: 'top-right',
    })
    // Оновлення журналу логів чи інші дії після успішного відправлення
    getInsuranceLogs()
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('API error:', error.response?.data || error.message)
      errorMessage.value = error.response?.data?.message || error.message
    } else {
      console.error('Unexpected error:', error)
      errorMessage.value = 'Unexpected error occurred'
    }
    resendInsuranceState.value = 'error'
    ElNotification({
      title: 'Error',
      message: `Failed to Resend Insurance: ${errorMessage.value}`,
      type: 'error',
      position: 'top-right',
    })
  }
}

onMounted(() => {
  if (!isInitialLoadingDone.value && !isLoading.value) {
    getInsuranceLogs()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (error.value)
    ? (_openBlock(), _createBlock(CommonError, {
        key: 0,
        errorMessage: error.value,
        onRetryPress: getInsuranceLogs
      }, null, 8, ["errorMessage"]))
    : (!isInitialLoadingDone.value || (isLoading.value && !list.value.length))
      ? (_openBlock(), _createBlock(Loader, { key: 1 }))
      : (_openBlock(), _createBlock(_component_el_scrollbar, {
          key: 2,
          always: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "title" }, "Logs", -1)),
                      _createVNode(_component_el_button, {
                        type: "primary",
                        onClick: resendInsurance,
                        loading: resendInsuranceState.value === 'loading'
                      }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createTextVNode("Resend Insurance")
                        ])),
                        _: 1,
                        __: [0]
                      }, 8, ["loading"])
                    ]),
                    (list.value.length)
                      ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (insuranceLog) => {
                              return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                placement: "top",
                                size: "large",
                                key: insuranceLog.id,
                                timestamp: _unref(formatDateWithTime)(insuranceLog.created_at)
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                      _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Status:", -1)),
                                      _createElementVNode("p", null, _toDisplayString(insuranceLog.car_profile_insurance_request_status), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_4, [
                                      _cache[3] || (_cache[3] = _createElementVNode("h4", null, "Comment:", -1)),
                                      _createElementVNode("p", null, _toDisplayString(insuranceLog.comment), 1)
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["timestamp"]))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("h5", _hoisted_5, "No Logs"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
}
}

})